require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j-2020-21.json") })
        }
      }, "path---kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j-2020-21");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j-2020-21!./.cache/json/kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j-2020-21.json
// module id = 1110
// module chunks = 231608221292675